module.exports = __webpack_public_path__ + "media/images/beauty/card-mobile-e6070eb9d8a510abba0f8b11bb7a4e06.jpg";